module.exports = __webpack_public_path__ + "img/banner.751946e0.png";